import { gql } from "@apollo/client";

export const Client = gql`
query Active_clients {
    aatmsv4_clients(order_by: {clientname: asc}, where: {active: {_eq: true}}) {
      clientname
      clientsid
    }
  }
`

export const Fleet = gql`
query fleets_for_a_given_client(
    $clientId: uuid
) {
    aatmsv4_fleets(order_by: {_aircraft: asc}, where: {clientsid: {_eq: $clientId}}) {
      fleetsid
      aircraft
    }
  }
`
export const catagories = gql`
query categories { aatmsv4_category(order_by: {categoryid: asc}) {
    categoryid
  }
}
`
export const Get_StcFormData = gql`
query da_simform_tc_stcquerys(
  $simformname: String
) {
  aatmsv4_stcmap(where: {simformname: {_eq: $simformname }}, order_by: {sequence: asc}) {
    sequence
    phase
    stcname
  }
}`;

export const Subcatagory = gql`
query subcategories{
    aatmsv4_subcategory(order_by: {subcategoryid: asc}) {
        subcategoryid
      }
    }
`
export const Phase = gql`
query MyQuery {
    aatmsv4_phase(order_by: {phaseid: asc}) {
      phaseid
    }
  }
`
export const simform = gql`
query da_simform_tc(
    $clientId: uuid
    $fleetsid: uuid
    $phaseid: aatmsv4_phase_enum
) {
    aatmsv4_stclist(order_by: {stcname: asc}, where: {client: {clientsid: {_eq: $clientId}, _and: {fleets: {fleetsid: {_eq: $fleetsid}, _and: {_and: {active: {_eq: true}}}}}}, phase: {_eq: $phaseid}}) {
      stcid
      stcname
      ata
      stcshortname
    }
  }
`
export const simform_Query = gql`
query MyQuery(
  $clientId: uuid
  $fleetId: uuid
) {
  aatmsv4_simforms(where: {clientsid: {_eq: $clientId}, fleetsid: {_eq: $fleetId}}) {
    active
    blankform
    category
    clientname
    cost
    ntc
    minutes
    presentation
    reginfo
    remarks
    result
    simformname
    studymat
    subcategory
    tc
    validity
  }
}
`
export const stcForm = gql`
mutation da_simform_tc_tempstore(
  $stcid: uuid
  $stcname: String
  $ata: Int
  $phase: aatmsv4_phase_enum
  $simformName: String
  $sequence: Int
  $stcshortname: String
) {
  insert_aatmsv4_stcmap(objects: {simformname: $simformName,stcid: $stcid, ata: $ata, stcname: $stcname, stcshortname: $stcshortname, phase: $phase, sequence: $sequence, _crew: true, _ground: true, _simulator: true, _aircraft: true, _manager: true, _optimiser: true, active: false, published: false}) {
    returning {
      stcmapid
      published
      active
    }
  }
}
`
export const Insert_SimForm = gql`
mutation da_simform_(
  $clientsid: uuid
  $clientname: String
  $fleetsid: uuid
  $minutes: Int
  $validity: Int
  $subcatagory: aatmsv4_subcategory_enum
  $simformname: String
  $regInfo: String
  $ntc: Boolean
  $remarks: Boolean
  $result: Boolean
  $preview: Boolean
  $active: Boolean
  $published: Boolean,
  $stage: Int,
  $tc: Boolean
  $url : String
  $email: String
) {
  insert_aatmsv4_simforms(objects: {
    active: $active,
    blankformname: $url,
    category: Simulator,
    clientname: $clientname,
    clientsid: $clientsid,
    fleetsid: $fleetsid,
    manageremail: $email,
    minutes: $minutes,
    validity: $validity,
    ntc: $ntc,
    preview: $preview,
    published: $published,
    reginfo: $regInfo,
    remarks: $remarks,
    blankform: $url,
    result: $result,
    simformname:$simformname,
    stage: $stage,
    subcategory: $subcatagory,
    tc: $tc}) {
    returning {
      clientsid
      client {
        logo
        clientname
        department
        headerrh1
        headerrh2
        headerrh3       
      }
      simformname
      minutes
      preview
      ntc
      remarks
      tc
      result
      reginfo
      simformid
      manageremail  
      stage     
      fleetsid
      fleet {
        aircraft
      }
    }
  }
}`
export const addmanagerSim = gql`
mutation da_simform_add_Choose3ManagersDropdown($emailofficial: String, $clientid: uuid, $dates: date, $name: String, $managerid: String, $formid: uuid, $siminstructorid: String) {
  insert_aatmsv4_smap(objects: {active: true, addedby: $emailofficial, addedon: $dates, clientsid: $clientid, simformname: $name, simmanagerid: $managerid, simformid: $formid, siminstructorid: $siminstructorid}) {
    returning {
      smapid
    }
  }
}

`
export const addmanagerSim2 = gql`
mutation da_simform_add_Choose3ManagersDropdown2($emailofficial: String, $clientid: uuid, $dates: date, $name: String, $managerid: String, $formid: uuid, $siminstructorid: String) {
  insert_aatmsv4_smap(objects: {active: true, addedby: $emailofficial, addedon: $dates, clientsid: $clientid, simformname: $name, simmanagerid: $managerid, simformid: $formid, siminstructorid: $siminstructorid}) {
    returning {
      smapid
    }
  }
}
`
export const addmanagerSim3 = gql`
mutation da_simform_add_Choose3ManagersDropdown3($emailofficial: String, $clientid: uuid, $dates: date, $name: String, $managerid: String, $formid: uuid, $siminstructorid: String) {
  insert_aatmsv4_smap(objects: {active: true, addedby: $emailofficial, addedon: $dates, clientsid: $clientid, simformname: $name, simmanagerid: $managerid, simformid: $formid, siminstructorid: $siminstructorid}) {
    returning {
      smapid
    }
  }
}
`
export const Cencel_Stc_Map = gql`
mutation da_simform_cancel {
  delete_aatmsv4_stcmap(where: {active: {_eq: false}, published: {_eq: false}}) {
    returning {
      stcmapid
    }
  }
}
`
export const add_simform = gql `
mutation da_simform_publish2(
  $name: String
  $Id: uuid
  ) {
  update_aatmsv4_stcmap(_set: {active: true, published: true, simformid: $Id}, where: {simformname: {_eq: $name}}) {
    returning {
      sequence
      phase
      stcname
      published
      active
      stcmapid
      simformid
    }
  }
}
`

export const managerDropdown = gql`
query DA_simform_new_instructormanager_3_dropdown(
  $id: uuid
  $clientid: uuid
) {
  aatmsv4_simulatorinst(order_by: {name: asc}, where: {clientsid: {_eq: $clientid},
  active: {_eq: true}, fleetsid: {_eq: $id}}) {
  name
  usersid
  emailofficial
  } 
}
`
export const gettingUserFleet = gql`
query MyQuery(
  $id: String
) {
  aatmsv4_register(where: {userid: {_eq: $id}}) {
    fleetsid
    emailofficial
  }
}
`
export const updatesimform = gql`
mutation Da_simform_add_updateAndPreview(
  $simformid: uuid,
  $active: Boolean,
  $clientname: String,
  $clientsid: uuid,
  $fleetsid: uuid,
  $minutes: Int,
  $ntc: Boolean,
  $reginfo: String,
  $remarks: Boolean,
  $result: Boolean,
  $simformname:String,
  $subcategory: aatmsv4_subcategory_enum,
  $tc: Boolean,
  $validity: Int
  $url: String
  $email: String
  $stage: Int,
  $preview: Boolean
  $published: Boolean
  $simformid1: uuid
  ) {
  update_aatmsv4_simforms(where: {simformid: {_eq: $simformid}}, _set: {active: $active, blankform: $url, category: Simulator, clientname: $clientname, clientsid: $clientsid, fleetsid: $fleetsid,
  manageremail: $email, minutes: $minutes, ntc: $ntc, preview: $preview, published: $published, reginfo: $reginfo,
  remarks:$remarks, result: $result, simformid: $simformid1, simformname: $simformname, stage: $stage, subcategory: $subcategory, tc:$tc, validity: $validity}) {
  returning {
  simformid
  }
  }
  }
`
export const published = gql`
mutation Da_simform_add_updateAndPreview(
  $clientname: String,
  $clientsid: uuid,
  $fleetsid: uuid,
  $minutes: Int,
  $ntc: Boolean,
  $reginfo: String,
  $remarks: Boolean,
  $result: Boolean,
  $simformid1: uuid,
  $simformname: String,
  $subcategory: aatmsv4_subcategory_enum,
  $tc: Boolean,
  $url: String,
  $email: String
  $validity: Int) {
  update_aatmsv4_simforms(where: {simformid: {_eq: $simformid1}}, _set: {active: true, blankform: $url, category: Simulator, clientname: $clientname, clientsid: $clientsid, fleetsid: $fleetsid, manageremail: $email, minutes: $minutes, ntc: $ntc, preview: true, published: true, reginfo: $reginfo, remarks: $remarks, result: $result, simformid: $simformid1, simformname: $simformname, stage: 1, subcategory: $subcategory, tc: $tc, validity: $validity}) {
    returning {
      simformid
    }
  }
}
`
export const stcpublished = gql`
mutation Da_simform_new_publish2(
  $simformname: String
  $simformid: uuid
  ){
  update_aatmsv4_stcmap(where: {simformname: {_eq: $simformname}}, _set: {active: true, published: true, simformid: $simformid}) {
    returning {
      simformname
    }
  }
}
`